import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { TrainingModuleConfig } from "./moduleConfigs";
import { TrainingModuleProvider } from "./TrainingModuleContext";

interface TrainingModuleLayoutProps {
  config: TrainingModuleConfig;
}

const TrainingModuleLayout: React.FC<TrainingModuleLayoutProps> = ({
  config,
}) => {
  const location = useLocation();

  if (location.pathname === config.basePath) {
    return <Navigate to={config.paths.dashboard} replace />;
  }

  return (
    <TrainingModuleProvider config={config}>
      <Outlet />
    </TrainingModuleProvider>
  );
};

export default TrainingModuleLayout;
